import { ValidationPointageMobile } from '../../components/mobile/ValidationPointage';
import { ValidationPointageWeb } from '../../components/web/ValidationPointage';
import withPlatformComponent from '../../components/withPlatformComponent';

const ValidationPointage = withPlatformComponent({
    web: ValidationPointageWeb,
    mobile: ValidationPointageMobile,
});

export default ValidationPointage;
